import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const { clearData } = reducer.actions

export const sendEmailNotification = createAction(
  'notifications/sendEmailNotification'
)
